/**
 * 
 * @param count Number of animation frames to wait for.
 */
export async function requestAnimationFramePromise(count = 1) {
  for (let i=0; i<count; i++) {
    await new Promise<void>((resolve) => {
      requestAnimationFrame(() => {
        resolve();
      });
    })
  }
};